import { AccountAdditionalInfoItemFormatingType } from './AccountAdditionalInfoItemFormatingType';
export class AdditionalInfoItem {
    constructor() {
        // +++
        this.UseColor = false;
    }
    Update(item) {
        this.GroupInfo = item.GroupInfo;
        this.SortIndex = item.SortIndex;
        this.NameKey = item.NameKey;
        this.ToolTipKey = item.ToolTipKey;
        this.DataType = item.DataType;
        this.Value = item.Value;
        this.Visible = item.Visible;
        this.UseColor = item.UseColor;
        this.APIKey = item.APIKey;
    }
}
export class InstrumentAdditionalInfoItem extends AdditionalInfoItem {
}
export class AccountAdditionalInfoItem extends AdditionalInfoItem {
    constructor() {
        super(...arguments);
        this.Destination = AccountAdditionalInfoDestinationPanel.AllPanels;
        /// <summary>
        /// ипользуется в связске с  AccountAdditionalInfoItemFormatingType.CustomAsset для форматирования в заданном ассете
        /// </summary>
        this.CustomAssetID = null;
        this.GroupIndex = null;
    }
    Update(item) {
        super.Update(item);
        if (item) {
            this.FormatingType = item.FormatingType;
            this.Destination = item.Destination;
            this.CustomAssetID = item.CustomAssetID;
            this.GroupIndex = item.GroupIndex;
        }
    }
    GetFormatValue(assetBalance) {
        let val = this.Value;
        if (!val) {
            val = 0;
        } // #113807
        // +++ support formating for custom data
        switch (this.FormatingType) {
            case AccountAdditionalInfoItemFormatingType.AssetBalance:
                if (assetBalance) {
                    return assetBalance.formatPriceExactly(val);
                }
                else {
                    return val.toString();
                }
            default:
                return val.toString();
        }
    }
}
export var AccountAdditionalInfoDestinationPanel;
(function (AccountAdditionalInfoDestinationPanel) {
    AccountAdditionalInfoDestinationPanel[AccountAdditionalInfoDestinationPanel["AccountsDetails"] = 1] = "AccountsDetails";
    AccountAdditionalInfoDestinationPanel[AccountAdditionalInfoDestinationPanel["OERiskDetails"] = 2] = "OERiskDetails";
    AccountAdditionalInfoDestinationPanel[AccountAdditionalInfoDestinationPanel["AllPanels"] = 3] = "AllPanels";
})(AccountAdditionalInfoDestinationPanel || (AccountAdditionalInfoDestinationPanel = {}));
